import { BasicPage } from "../../theme/Component/BasicPage"
import { useEffect, useState } from "react"
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import { Singleton } from "../../../core/services/Singleton";

import { BasicTable, MASK_DATE } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import { AdminService } from "../../../core/services/AdminService";
import { InputDate } from "../../theme/Input/InputDate";

import { useDashboardStore } from "../../pages/hooks/useDashboardStore";
import { toast } from "react-toastify";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../contract/select/SelectMonths";
import { BasicButton } from "../../theme/Component/BasicButton";
import useModal, { MODAL_SM } from "../../theme/Component/hooks/useModal";
import { FileInput } from "../../theme/Component/FileInput";
import { _single } from "../../../core/services/dataBean/EntityCatalog";





export const FestiveDay = () => {

    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service = new AdminService();
    const [lista, setLista] = useState([]);
    const [modal, setModal] = useState<any>({ name: 'Permisos', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const [bean, setBean] = useState<any>({});


    const [year, setYear] = useState<any>(new Date().getFullYear());
    const [month, setMonth] = useState<any>(new Date().getMonth());
    const [file, setFile] = useState<any>({});
    const modalImportar = useModal("Importar", MODAL_SM);

    const idBean = 'IDFestivalDay';

    const head = [
        { title: 'ID', property: idBean },
        { title: 'Dia', property: 'Day', mask: MASK_DATE },
        { title: 'Descripción', property: 'Description' },

    ]

    useEffect(() => {

        getLista();
    }, [])

    const setRowBean = (bean: any) => {
        //console.log("Row : ", bean);
        setBean(bean);

    }

    const getLista = () => {

        setLoading(true);
        service.getFestiveDayRender(year, month).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                else if (resp.DataBeanProperties.ErroMessage) {
                    toast.error(resp.DataBeanProperties.ErroMessage);
                }


                setLoading(false);
            }
        );
    }



    const agregarItem = () => {

        let b = {
            Day: single.getCurrenDate(),
            Description: '',

            State: 1,
        }
        setBean(b);
        setModal({ ...modal, ['view']: true });
    }

    const editarItem = () => {
        setModal({ ...modal, ['view']: true });
    }

    const eliminarItem = () => {

        setLoading(true);
        service.deleteFestiveDay(bean[idBean]).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp) {
                    getLista();
                }
                single.delete(bean[idBean], bean);
            }
        );
        setModalConfirm({ ...modalConfirm, ['view']: false });
    }

    const updateItem = () => {
        //console.log(bean);
        setModal({ ...modal, ['view']: false });
        setLoading(true);
        service.updateFestiveDay(bean).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp.DataBeanProperties.ObjectValue) {
                    getLista();
                }
                single.update(bean);
            });
    }



    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-file-list-line', visible: true, evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: true, evento: () => { setModalConfirm({ ...modalConfirm, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const importarItem = () => {
        setLoading(true);
        service.importFestiveDay(_single.getAccountID(), file.Media, file.MediaContext).subscribe((resp: any) => {
            setLoading(false);
            if (resp) {
                getLista();
                modalImportar.close();
            }
        })
    }


    const iconButtonsItem = [
        { nombre: 'Importar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: () => { modalImportar.open() } },
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }
    ]

    return (
        <>
            <BasicPage titulo="Calendario Festivos">
                <div className="row">
                    <div className="col-md-4">
                        <YearSelector tittle="Año" value={year} onChange={setYear} />
                    </div>
                    <div className="col-md-4">
                        <SelectMonths label="Mes" idSelector={month} onChange={setMonth} />
                    </div>
                    <div className="col-md-4">
                        <BasicButton useMargin icon="ri-search-line" eventClick={() => { getLista() }} >Buscar</BasicButton>
                    </div>
                    <div className="col-md-12 p-2">
                        <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean}></BasicTable>
                    </div>
                </div>
            </BasicPage>
            <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                {bean.Name}
            </ModalConfirm>
            <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                <div className="row">
                    <div className="col-md-12">
                        <InputDate label="Día" name="Desde" value={bean.Day} setDate={(e: any) => { setBean({ ...bean, 'Day': e }) }} ></InputDate>
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Descripción</label>
                        <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, ['Description']: e.target.value }) }}></textarea>
                    </div>
                </div>
            </Modal>
            <Modal modal={modalImportar.modal} updateModal={modalImportar.setModal} eventModal={importarItem} onSubmitLabel="Importar">
                <div className="row">
                    <div className="col-md-12">
                        <FileInput directory="temp" onCreate={setFile} />
                    </div>
                    <div className="col-md-12 mt-4">
                        <strong>Formato Archivo</strong><br />
                        Fecha | Descripción
                    </div>
                </div>
            </Modal>
        </>
    )
}